import styled from "styled-components";

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  .gatsby-image-wrapper {
    height: 100%;
    img {
      display: flex;
      object-fit: cover;
    }
  }
`;

export const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
`;

interface TrackProps {
  slidesCount: number;
  currentSlide: number;
}

const width = ({ slidesCount }: TrackProps) => `calc(${slidesCount}00%)`;

export const Track = styled.div`
  width: ${width};
  display: flex;
  padding-bottom: -50%;
  align-items: flex-start;
  transition: 300ms ease;
  transition-property: transform, height;
  transform: translateX(
    -${({ slidesCount, currentSlide }: TrackProps) => (100 / slidesCount) * currentSlide}%
  );
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 15px;
  width: 100%;
  justify-content: center;
  display: flex;
  left: 0;
  right: 0;
`;

interface DotProps {
  active: boolean;
}

function dotWidth({ active }: DotProps) {
  return active ? "16px" : "8px";
}

function dotRadius({ active }: DotProps) {
  return active ? "5px" : "50%";
}

export const Dot = styled.div`
  width: ${dotWidth};
  height: 8px;
  background-color: white;
  border-radius: ${dotRadius};
  transition: 150ms;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 10px;
  }
`;
